import {Directive, HostBinding, Input} from '@angular/core';

const palettes = {
    success: {background: '#163b2b', text: '#a7f3c5', border: '#357552'},
    active: {background: '#433711', text: '#fde68a', border: '#927422'},
    queued: {background: '#571a40', text: '#f9a8d4', border: '#a83276'},
    error: {background: '#481f29', text: '#fecdd3', border: '#a5485c'},
    unavailable: {background: '#492c15', text: '#fed7aa', border: '#a8662c'},
    neutral: {background: '#292d3b', text: '#d4d8e4', border: '#586074'}
};

@Directive({selector: '[appOrderStatus]', standalone: false})
export class OrderStatusDirective {
    @Input() appOrderStatus: unknown;
    @HostBinding('class.order-state-badge') readonly badge = true;

    @HostBinding('style.background-color') get background() {
        return this.palette.background;
    }

    @HostBinding('style.color') get color() {
        return this.palette.text;
    }

    @HostBinding('style.border-color') get border() {
        return this.palette.border;
    }

    private get palette() {
        const status = String(this.appOrderStatus ?? '').toLowerCase().replace(/[\s_-]/g, '');
        if (status === 'queued') return palettes.queued;
        if (status === 'finished') return palettes.success;
        if (status === 'nocarfound') return palettes.unavailable;
        if (['timeout', 'servertimeout', 'clientcanceled', 'drivercanceled',
            'canceledbycustomer', 'canceledbyclient', 'canceledbydriver',
            'cancelledbycustomer', 'cancelledbydriver', 'error', 'failed'].includes(status)) return palettes.error;
        if (['created', 'assigned', 'approaching', 'arrived', 'clientpicked',
            'ontheway'].includes(status)) return palettes.active;
        return palettes.neutral;
    }
}
